import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { formatApiErrorDetail } from "@/lib/api";
import CinemaBrand from "@/components/CinemaBrand";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const u = await login(email, password);
      if (u.role === "snack") navigate("/admin/snackbar");
      else if (u.role === "door") navigate("/admin/scanner");
      else navigate("/admin");
    } catch (e) {
      const status = e.response?.status;
      if (status === 401 || status === 422) setErr("E-Mail oder Passwort ist falsch");
      else if (status === 429) setErr("Zu viele Fehlversuche. Bitte 15 Minuten warten.");
      else setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4 overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1705944601101-fdb49dbf884c?w=1920"
          alt=""
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black" />
      </div>
      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <CinemaBrand size="xl" stacked />
        </div>
        <form onSubmit={submit} className="card-lux p-8 gold-glow">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[#A8A398] mb-6">Anmeldung</div>

          <label className="block text-xs uppercase tracking-widest text-[#A8A398] mb-2">E-Mail</label>
          <input
            data-testid="login-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full mb-5 bg-[#0A0A0A] border border-[#2A2A2A] rounded-md px-4 py-3 text-[#F5F0E6] focus:border-[#D4AF37] focus:outline-none transitions-safe"
            placeholder="mail@moviehouse.local"
          />

          <label className="block text-xs uppercase tracking-widest text-[#A8A398] mb-2">Passwort</label>
          <input
            data-testid="login-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full mb-5 bg-[#0A0A0A] border border-[#2A2A2A] rounded-md px-4 py-3 text-[#F5F0E6] focus:border-[#D4AF37] focus:outline-none transitions-safe"
          />

          {err && (
            <div data-testid="login-error" className="mb-4 text-sm text-[#EE9CA1] bg-[#5B1319]/30 border border-[#5B1319] rounded-md px-3 py-2">
              {err}
            </div>
          )}

          <button
            data-testid="login-submit-btn"
            type="submit"
            disabled={busy}
            className="w-full py-3 bg-[#D4AF37] hover:bg-[#EEDC82] text-black font-medium tracking-widest uppercase text-sm rounded-md transitions-safe disabled:opacity-50"
          >
            {busy ? "Bitte warten …" : "Einlass"}
          </button>

          <div className="mt-6 text-center text-xs text-[#757169] space-x-3">
            <Link to="/program" className="hover:text-[#D4AF37] transitions-safe">Filmprogramm →</Link>
            <span>·</span>
            <Link to="/mitglied/login" className="hover:text-[#D4AF37] transitions-safe">Mitglied? Einloggen →</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
